export const VISIBILITY_STATUS_IDS = [0, 1, 2]
